// extracted by mini-css-extract-plugin
export var active = "_eo-7";
export var container = "_eo-0";
export var evenWidth = "_eo-4";
export var large = "_eo-5";
export var outlet = "_eo-8";
export var slide = "_eo-2";
export var small = "_eo-6";
export var tab = "_eo-3";
export var tabs = "_eo-1";